import React from 'react';
import PropTypes from 'prop-types';
import Loader from '../loader.jsx';
import Markdown from 'react-remarkable';

let ArticleContents = ({article, formatMessage}) => {
  let loaded = !!article;

  article = article || {};
  return (
    <div className='article-contents'>
      <Loader loaded={loaded}>
        <Markdown options={{html: true}}>
          <h1>{article.title}</h1>
          {article.body}
          <div className='article-footer'>
            <p>
              {formatMessage({id: 'encyclopedia.description'})}
            </p>
          </div>
        </Markdown>
      </Loader>
    </div>
  );
};

ArticleContents.propTypes = {
  article: PropTypes.object.isRequired,
  formatMessage: PropTypes.func.isRequired,
};

export default ArticleContents;
